export const LOCAL_STORE_RECORD_SPECIALIST = 'record=specialist';
export const LOCAL_STORE_RECORD_SERVICE = 'record=service';
export const LOCAL_STORE_RECORD_DATE = 'record=date';
export const LOCAL_STORE_REPORT_DATE = 'report=date';